var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgBackArrow = function SvgBackArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6.919,
    height: 11.664
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 236"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 540",
    d: "M6.695 11.439a.767.767 0 01-1.085 0l-4.7-4.7 1.084-1.085 4.7 4.7a.767.767 0 010 1.084z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 674",
    d: "M6.694.229a.767.767 0 010 1.085L1.085 6.923 0 5.839 5.609.229a.768.768 0 011.085 0z"
  }))));
};

export default SvgBackArrow;